
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3d-web-experience",
      function () {
        return require("private-next-pages/3d-web-experience.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3d-web-experience"])
      });
    }
  